import { render, staticRenderFns } from "./InteractionTypeSelect.vue?vue&type=template&id=0c9342fd&scoped=true&"
import script from "./InteractionTypeSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./InteractionTypeSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9342fd",
  null
  
)

export default component.exports